export default function QuantityInput({
  quantity,
  increaseValue,
  decreaseValue,
  name,
  register,
}) {
  return (
    <>
      <div className="quantity flex">
        <input
          type="button"
          value="+"
          className="plus h-[42px] border cursor-pointer border-light-gray-300 min-w-[25px] px-1 rounded-[0_5px_5px_0] text-gray-300"
          onClick={() => increaseValue()}
        />
        <input
          type="number"
          className="input-text qty text w-[30px] h-[42px] border border-light-gray-300 p-0 text-center "
          step="1"
          min="1"
          name={name ?? 'quantity'}
          value={quantity}
          title="تعداد"
          size="4"
          placeholder=""
          {...(register ? register(name) : {})}
        />
        <input
          type="button"
          value="-"
          className="minus h-[42px] border cursor-pointer border-light-gray-300  min-w-[25px] px-1 rounded-[5px_0_0_5px] text-gray-300"
          onClick={() => decreaseValue()}
        />
      </div>
    </>
  );
}
